import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddNewRecipientFromSendPaymentComponent } from '@pg-app/client/send-payment-instruction/containers/add-new-recipient/add-new-recipient-from-payment.component';
import { AddRecipientFromSendPaymentGuard } from './add-recipient-from-send-payment.guard';

const routes: Routes = [
  {
    path: 'add-new-recipient',
    component: AddNewRecipientFromSendPaymentComponent,
    canActivate: [AddRecipientFromSendPaymentGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SendPaymentInstructionRoutingModule { }
